module.exports = __webpack_public_path__ + "img/8.004879b9.png";